import React from "react"

const Copylight = () => {
  const now = new Date
  const year = now.getFullYear()
  return <p className="copyligth"><small>All Rights Reserved, Copyright &copy; {year} 川崎重工・フジタ・会津土建・梓・白井特定建設工事共同企業体</small></p>
}

export default Copylight